import qs from 'query-string';
import SelectService from '../service/SelectService';

SelectService.onChange('site-language', (language) => {
    const options = { arrayFormat: 'bracket' };
    const search = qs.parse(window.location.search, options);
    search.language = language;
    window.location.search = qs.stringify(search, options);
});
